export enum MessageTypeEnum {
    ACTION_PROGRESS = 'ACTION_PROGRESS',
    ACTION_COMPLETED = 'ACTION_COMPLETED',
    QUOTING_QUEUED = 'QUOTING_QUEUED',
    QUOTING_IN_PROGRESS = 'QUOTING_IN_PROGRESS',
    QUOTING_COMPLETE = 'QUOTING_COMPLETE',
    QUOTING_MESSAGE = 'QUOTING_MESSAGE',
    ACTION_UPDATE = 'ACTION_UPDATE'
}
